import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import React from "react";
var useImageLazyLoadingBoundary = function useImageLazyLoadingBoundary(_ref) {
  var containerRef = _ref.containerRef,
    enabled = _ref.enabled;
  var imagesRefs = React.useRef([]);
  var hasBeenEnabledRef = React.useRef(enabled);
  hasBeenEnabledRef.current = hasBeenEnabledRef.current || enabled;
  React.useEffect(function () {
    if (enabled && imagesRefs.current.length > 0) {
      var _context;
      _forEachInstanceProperty(_context = imagesRefs.current).call(_context, function (node) {
        _globalThis.lazySizes.loader.unveil(node);
      });
      imagesRefs.current = [];
    }
  }, [enabled]);
  React.useEffect(function () {
    // https://github.com/aFarkas/lazysizes/blob/gh-pages/src/lazysizes-core.js#L293
    var canScroll = 'onscroll' in _globalThis && !/(gle|ing)bot/.test(navigator.userAgent);

    // If browser can't scroll, allow lazysizes to load images as it normally would.
    // This is necessary for SEO
    if (!canScroll) {
      return;
    }
    var listener = function listener(evt) {
      if (!hasBeenEnabledRef.current) {
        evt.preventDefault();
        imagesRefs.current.push(evt.target);
      }
    };
    containerRef.current.addEventListener('lazybeforeunveil', listener);

    // eslint-disable-next-line consistent-return
    return function () {
      var _containerRef$current;
      // eslint-disable-next-line react-hooks/exhaustive-deps
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.removeEventListener('lazybeforeunveil', listener);
    };
  }, [containerRef]);
};
export default useImageLazyLoadingBoundary;